import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
// Removed QueryClient for simplified site
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import NetworkStatusIndicator from "@/components/NetworkStatusIndicator";
// Removed session heartbeat for simplified site
import Index from "./pages/Index";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import NotFound from "./pages/NotFound";
import TrabalheConosco from "./pages/TrabalheConosco";
import SAC from "./pages/SAC";
import Produtos from "./pages/Produtos";
import Fornecedores from "./pages/Fornecedores";

// Removed QueryClient configuration for simplified site

const App = () => {
  return (
    <ErrorBoundary componentName="App">
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <NetworkStatusIndicator />
        <BrowserRouter>
            <ErrorBoundary componentName="LanguageProvider">
              <LanguageProvider>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/post/:slug" element={<BlogPost />} />
                  <Route path="/termos" element={<Terms />} />
                  <Route path="/privacidade" element={<Privacy />} />
                  <Route path="/cookies" element={<Cookies />} />
                  <Route path="/trabalheconosco" element={<TrabalheConosco />} />
                  <Route path="/sac" element={<SAC />} />
                  <Route path="/produtos" element={<Produtos />} />
                  <Route path="/fornecedores" element={<Fornecedores />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </LanguageProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </TooltipProvider>
    </ErrorBoundary>
  );
};

export default App;
